<template lang='pug'>
	.privacy-policy
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="Our Services and Prices")
		contentPrivacy
		v-e24-footer(:build="build")
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import contentPrivacy from '@/components/resources/content-prices.vue'
import imageHeader from '@/img/prices-header.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'prices',
	components: {
		headerResources,
		contentPrivacy
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Prices.vue